import createIcon from '../../createIcon';

/**
 * @component @name RestaurantMenu
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy43OTk0NSAxMy4xMjg1TDEwLjYyOTUgMTAuMjk4NUwzLjYwOTQ1IDMuMjg4NTNDMi4wNDk0NSA0Ljg0ODUzIDIuMDQ5NDUgNy4zNzg1MyAzLjYwOTQ1IDguOTQ4NTNMNy43OTk0NSAxMy4xMjg1Wk0xNC41Nzk1IDExLjMxODVDMTYuMTA5NSAxMi4wMjg1IDE4LjI1OTUgMTEuNTI4NSAxOS44NDk1IDkuOTM4NTNDMjEuNzU5NSA4LjAyODUzIDIyLjEyOTUgNS4yODg1MyAyMC42NTk1IDMuODE4NTNDMTkuMTk5NSAyLjM1ODUzIDE2LjQ1OTUgMi43MTg1MyAxNC41Mzk1IDQuNjI4NTNDMTIuOTQ5NSA2LjIxODUzIDEyLjQ0OTUgOC4zNjg1MyAxMy4xNTk1IDkuODk4NTNMMy4zOTk0NSAxOS42NTg1TDQuODA5NDUgMjEuMDY4NUwxMS42OTk1IDE0LjE5ODVMMTguNTc5NSAyMS4wNzg1TDE5Ljk4OTUgMTkuNjY4NUwxMy4xMDk1IDEyLjc4ODVMMTQuNTc5NSAxMS4zMTg1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RestaurantMenu = createIcon('RestaurantMenu', [
  [
    'path',
    {
      d: 'M7.79945 13.1285L10.6295 10.2985L3.60945 3.28853C2.04945 4.84853 2.04945 7.37853 3.60945 8.94853L7.79945 13.1285ZM14.5795 11.3185C16.1095 12.0285 18.2595 11.5285 19.8495 9.93853C21.7595 8.02853 22.1295 5.28853 20.6595 3.81853C19.1995 2.35853 16.4595 2.71853 14.5395 4.62853C12.9495 6.21853 12.4495 8.36853 13.1595 9.89853L3.39945 19.6585L4.80945 21.0685L11.6995 14.1985L18.5795 21.0785L19.9895 19.6685L13.1095 12.7885L14.5795 11.3185Z',
      key: '10jvb0',
    },
  ],
]);

export default RestaurantMenu;
